/**
 * @constructor
 * @param {number} bet
 * @param {number} totalWin
 * @returns {FreeSpinsWinCounter}
 */
import {getRandomInt} from "../../framework/src/helpers";

export default function FreeSpinsWinCounter(bet, totalWin) {

    this._step = 0.1;
    this._currValue = 0;
    this._bet = bet;
    this._totalWin = totalWin;

    this._freq = 30;

    //this._add = totalWin / 100;
    this._randMin = (totalWin / (this._freq * 4)) | 0;
    this._randMax = (totalWin / (this._freq * 2)) | 0;
    this._add = 0; //totalWin / (this._freq * 2);

    this._onComplete = function() {};
    this._onUpdate = function() {};

    /** @type {Function} */
    this._resolver;

    //console.log(this._randMin, this._randMax);
}

FreeSpinsWinCounter.prototype.onUpdate = function(func) {
    this._onUpdate = func;
};

FreeSpinsWinCounter.prototype.onComplete = function(func) {
    this._onComplete = func;
};

FreeSpinsWinCounter.prototype._loop = function() {

    if(this._currValue >= this._totalWin) {
        this._onComplete(this._totalWin);
        //this._onUpdate(this._totalWin);
        this._resolver();
        return;
    }

    this._currValue += getRandomInt(this._randMin, this._randMax);   //(this._add | 0);

    this._onUpdate(this._currValue);

    setTimeout(this._loop.bind(this), this._freq);
};

/**
 * @returns {Promise}
 */
FreeSpinsWinCounter.prototype.run = function() {

    return new Promise(function(res) {
        this._resolver = res;

        this._loop();

    }.bind(this));
};